import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { ButtonComponent } from '@shared/components/button';
import { TitleComponent } from '@shared/components/title';
import { Title } from '@shared/components/title/model';

@Component({
  selector: 'app-form-layout-2-success',
  templateUrl: './form-layout-2-success.component.html',
  styleUrl: './form-layout-2-success.component.scss',
  imports: [ButtonComponent, TitleComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormLayout2SuccessComponent {
  readonly title = signal<Title>({
    level: 'H1',
    text: 'Nous avons bien reçu votre demande !',
    size: {
      mobile: 'H1',
      desktop: 'H1',
    },
    color: 'WHITE',
  });
}
